var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "0rjmvtp77a",
    d: "M0.007 0.242L363.594 0.242 363.594 134.881 0.007 134.881z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M181.806 434.844v-47.811 47.81z",
    transform: "translate(93 29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M173.306 434.843L190.306 434.843 190.306 387.033 173.306 387.033zM28.126 466.948L133.087 466.948 133.087 449.948 28.126 449.948zM225.43 466.948L335.487 466.948 335.487 449.948 225.43 449.948z",
    transform: "translate(93 29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M123.503 491.758h116.606v-64.806H123.503v64.806zm17-17h82.606v-30.806h-82.606v30.806z",
    transform: "translate(93 29)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M18.331 251.811v73.112c0 26.15 67.138 55.288 163.475 55.288 96.338 0 163.475-29.137 163.475-55.288V251.81H18.33zm163.475 145.4c-46.974 0-91.217-6.81-124.58-19.173-36.043-13.356-55.895-32.22-55.895-53.115V234.81h360.95v90.112c0 20.894-19.85 39.759-55.894 53.115-33.365 12.363-77.607 19.173-124.58 19.173z",
    transform: "translate(93 29) translate(0 .758)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CD9C2",
    d: "M356.41 158.996l-15.181 18.04-33.255 18.042-57.834 14.433-65.786 6.494-78.798-7.216-75.908-26.701L0 160.13v88.118c0 37.293 81.34 67.32 181.819 67.32 100.48 0 181.819-30.027 181.819-67.32v-90.752h-5.853l-1.376 1.499z",
    transform: "translate(93 29) translate(0 .758)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M18.331 85.775v71.545c0 26.15 67.138 55.288 163.475 55.288 96.338 0 163.475-29.137 163.475-55.288V85.775H18.33zm163.475 143.833c-46.974 0-91.217-6.81-124.58-19.172-36.043-13.357-55.895-32.221-55.895-53.116V68.775h360.95v88.545c0 20.895-19.85 39.759-55.894 53.116-33.365 12.363-77.607 19.172-124.58 19.172z",
    transform: "translate(93 29) translate(0 .758)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 29) translate(0 .758)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5310shhldb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0rjmvtp77a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7CD9C2",
    d: "M181.801.242c100.401 0 181.793 30.14 181.793 67.32 0 37.18-81.392 67.319-181.793 67.319C81.4 134.88.007 104.74.007 67.56.007 30.382 81.4.242 181.801.242",
    mask: "url(#5310shhldb)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSql);
export default __webpack_public_path__ + "static/media/icon--sql.61d853d15580540beb988f39323aa4c1.svg";
export { ForwardRef as ReactComponent };